import { render, staticRenderFns } from "./sell.vue?vue&type=template&id=228f41e8&scoped=true&"
import script from "./sell.vue?vue&type=script&lang=js&"
export * from "./sell.vue?vue&type=script&lang=js&"
import style0 from "./sell.vue?vue&type=style&index=0&id=228f41e8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "228f41e8",
  null
  
)

export default component.exports